<template>
    <div class="main">
        <LangSwitcher v-model="selectValue" :options="options" />
        <div v-for="(item, index) in newArr" :key="index">
            <!-- 主要内容 -->
            <div class="information">
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-ruleForm">
                    <!-- id -->
                    <el-form-item prop="id">
                        <div class="label">{{ item[4] }}:</div>
                        <el-input
                            v-model="ruleForm.id"
                            :placeholder="item[4]"
                            oninput="if(value.length>100)value=value.slice(0,100)"
                        ></el-input>
                    </el-form-item>
                    <!-- redemption -->
                    <el-form-item prop="redemption">
                        <div class="label">{{ item[5] }}:</div>
                        <el-input
                            v-model="ruleForm.redemption"
                            :placeholder="item[5]"
                            oninput="if(value.length>100)value=value.slice(0,100)"
                        ></el-input>
                    </el-form-item>
                    <!-- 验证码 -->
                    <div>
                        <el-form-item prop="verification">
                            <div class="label">{{ item[6] }}:</div>
                            <div class="verify">
                                <el-input v-model="ruleForm.verification" :placeholder="item[6]" id="verify"></el-input>
                                <div class="code" @click="refresh">
                                    <div v-show="!codeLoaded" class="code-loading">
                                        <div class="spinner"></div>
                                    </div>
                                    <img v-show="codeLoaded" :src="verificationCode" alt="" @load="codeLoaded = true" />
                                </div>
                            </div>
                        </el-form-item>
                        <el-form-item>
                            <div class="gText">*{{ item[10] }}</div>
                        </el-form-item>
                    </div>
                    <!-- 点击按钮 -->
                    <el-form-item>
                        <div class="exchange">
                            <div @click="submitForm" style="display: inline-block">
                                <img :src="pcBtnImg" alt="" />
                            </div>
                        </div>
                    </el-form-item>
                </el-form>
            </div>
            <!-- 展示信息 -->
            <div class="exhibit">
                <p>&copy; 2026 HABBY PTE. LTD. All Rights Reserved.</p>
            </div>
            <!-- 弹框 -->
            <ConfirmModal
                :visible="isModal"
                :loading="isLoading"
                :isMessage="isMessage"
                :title="'ID: ' + ruleForm.id"
                :subtitle="item[33]"
                :message="message"
                @yes="handleYes"
                @no="handleNo"
                @ok="handleOk"
            />
        </div>
    </div>
</template>

<script>
import giftExchange from '@/mixins/giftExchange'
import LangSwitcher from './LangSwitcher.vue'
import ConfirmModal from './ConfirmModal.vue'

const redeemMap = {
    'en': require('@/assets/images/pc/Redeem.png'),
    'ja': require('@/assets/images/pc/Redeem_jp.png'),
    'ko': require('@/assets/images/pc/Redeem_kr.png'),
    'zh-TW': require('@/assets/images/pc/Redeem_zh.png')
}

const exchangeMap = {
    'en': require('@/assets/images/pc/exchange_en.png'),
    'ja': require('@/assets/images/pc/exchange_jp.png'),
    'ko': require('@/assets/images/pc/exchange_kr.png'),
    'zh-TW': require('@/assets/images/pc/exchange_zh.png')
}

export default {
    mixins: [giftExchange],
    components: { LangSwitcher, ConfirmModal },
    computed: {
        pcBtnImg() {
            var lang = this.selectValue || 'en'
            return this.isDisable
                ? (exchangeMap[lang] || exchangeMap['en'])
                : (redeemMap[lang] || redeemMap['en'])
        }
    }
}
</script>

<style scoped lang="less">
@import '../styles/pc.less';
</style>
